module.exports = __webpack_public_path__ + "img/626A57_3B3F33_7D8973_444C3C-256px.db83bb44.png";